import { useState } from "react";
import { SyncProblem } from "@mui/icons-material";
import { CollapsibleItem } from "../../../../components/shared/sidebar/CollapsibleItem";

export const OSAD = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <CollapsibleItem
      title="OSAD"
      displayCount={0}
      icon={<SyncProblem />}
      isExpanded={isExpanded}
      onExpand={(value: boolean) => setIsExpanded(value)}
    />
  );
};
